export function isStyleDirtyForSave(
  field: string,
  initialData: any,
  currentValue: any,
  isFieldDirty: Record<string, boolean>
) {
  switch (field) {
    case "customSettingId":
      isFieldDirty.customSettingId = initialData.customSettingId != currentValue;
      break;
    case "customer":
      isFieldDirty.customer = initialData.customer.toLowerCase() != currentValue.toLowerCase();
      break;
    case "productCategory":
      isFieldDirty.productCategory = initialData.productCategory.toLowerCase() != currentValue.toLowerCase();
      break;
    case "productType":
      isFieldDirty.productType = initialData.productType.toLowerCase() != currentValue.toLowerCase();
      break;
    case "weightType":
      isFieldDirty.weightType = initialData.weightType.toLowerCase() != currentValue;
      break;
    case "color":
      isFieldDirty.color = initialData.color != currentValue;
      break;
    case "size":
      isFieldDirty.size = initialData.size != currentValue;
      break;
    case "noOfGarments":
      isFieldDirty.noOfGarments = initialData.quantity != currentValue;
      break;
    case "numberOfProductionLines":
      isFieldDirty.numberOfProductionLines = initialData.numberOfProductionLines != currentValue;
      break;
    case "description":
      isFieldDirty.description = initialData.description != currentValue;
      break;
  }
  return Object.values(isFieldDirty).some(Boolean);
}
export function resetField(isFieldDirty: Record<string, boolean>) {
  Object.entries(isFieldDirty).forEach(([key, _]) => {
    isFieldDirty[key] = false;
  });
}
